<template>
      <div id="albumFeature"> 
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark"> 精選相簿 </h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">相簿</li>
              <li class="breadcrumb-item active">精選相簿</li>
            </ol>
          </div>
          <!-- /.col --> 
        </div>
        <!-- /.row --> 
      </div>
      <!-- /.Container Fluid --> 
    </div>
    <!-- /.Content Header --> 
    
    <!-- Main content -->
    <div id="b-album" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-sm-10">
            <div class="b-filter"><a href="" class="current">全部</a><a href="">目前顯示中</a><a href="">過往精選項目</a></div>
          </div>
          <div class="col-sm-2">
            <button type="button" class="btn btn-block btn-primary btn-sm" data-toggle="modal" data-target="#modal-featured--set"><i class="nav-icon fas fa-plus fa-sm mr-1"></i> 新增精選相簿 </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <table id="featured-list" class="table table-bordered table-hover">
                  <thead>
                    <tr>
                      <th> 精選相簿 </th>
                      <th> 上傳者 </th>
                      <th> 類型 </th>
                      <th> 狀態</th>
                      <th> 加入精選日期 </th>
                      <th> 瀏覽量 </th>
                      <th> 自精選點擊量 </th>
                      <th> 轉化率 </th>
                      <th> 操作 </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="b-album-head"><div class="b-album-block mr-2">
                          <div class="b-album-thumbnail">
                            <div class="b-album-responsive">
                              <div class="b-album-sizer">
                                <div class="b-album-image" style="background-image: url('../../images/album/album-cover-1.jpg');"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <span class="b-title"><a href=""> 2020.05.27 北宜. 財茂彎午後雨中練習追焦 </a></span> <span class="b-tag"> <a> 北宜 </a><a> 財茂 </a><a> 雨 </a></span></td>
                      <td class="b-username"><a href=""> devin </a></td>
                      <td class="b-category"><a href=""> 重機 </a></td>
                      <td class="b-status"><span class="b-unpublished"> 隱藏中 </span></td>
                      <td class="b-date"> 2020年03月31日 </td>
                      <td class="cell-sm b-view-count"> 18,293 </td>
                      <td class="cell-sm b-click-count"> 10 </td>
                      <td class="cell-sm b-conversion-rate"> 5% </td>
                      <td class="cell-sm b-operate"><span type="button" class="b-operate-btn b-danger" data-toggle="modal" data-target="#modal-featured--remove"> 從精選移除 </span></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th> 精選相簿 </th>
                      <th> 上傳者 </th>
                      <th> 類型 </th>
                      <th> 狀態</th>
                      <th> 加入精選日期 </th>
                      <th> 瀏覽量 </th>
                      <th> 自精選點擊量 </th>
                      <th> 轉化率 </th>
                      <th> 操作 </th>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <!-- /.card-body --> 
            </div>
          </div>
          <!-- /.col-12 --> 
        </div>
        <!-- /.row --> 
      </div>
      <!-- /.Container Fluid --> 
      <!-- Modal: 新增/編輯精選相簿 -->
      <div class="modal fade" id="modal-featured--set">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">新增/編輯精選相簿</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>精選相簿類型</label>
                <select class="form-control select2-no-search" style="width: 100%;">
                  <option selected="selected">請選擇</option>
                  <option>重機</option>
                  <option>路跑</option>
                  <option>單車</option>
                  <option>鐵人</option>
                  <option>球類運動</option>
                  <option>水上運動</option>
                  <option>綜合運動</option>
                  <option>風景生活</option>
                </select>
              </div>
              <div class="form-group">
                <label>相簿名稱</label>
                <select class="form-control select2" style="width: 100%;">
                  <option selected="selected">(顯示該類別最近50項相簿名稱)</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                  <option>6</option>
                  <option>7</option>
                  <option>8</option>
                  <option>9</option>
                </select>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
              <button type="button" class="btn btn-primary featured--set---success" data-dismiss="modal">保存</button>
            </div>
          </div>
          <!-- /.modal-content --> 
        </div>
        <!-- /.modal-dialog --> 
      </div>
      <!-- /.modal: 新增/編輯精選相簿 --> 
      <!-- Modal: 移除精選相簿 -->
      <div class="modal fade" id="modal-featured--remove">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <p>將相簿<b>「相簿名稱」</b>從精選相簿中移除？</p>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
              <button type="button" class="btn btn-danger featured--remove---success" data-dismiss="modal">是，移除</button>
            </div>
          </div>
          <!-- /.modal-content --> 
        </div>
        <!-- /.modal-dialog --> 
      </div>
      <!-- /.modal: 移除精選相簿 --> 
    </div>
    <!-- /.Content --> 
  </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    created(){},
    methods:{
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/AdminAlbum/AlbumFeature.vue